"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.E2EBlossomMessages = void 0;
class E2EBlossomMessages {
    constructor(extensionId) {
        this.extensionId = extensionId;
    }
    sendMessage(action, parameters) {
        return new Promise((resolve, reject) => {
            chrome.runtime.sendMessage(this.extensionId, { action, data: parameters }, (response) => {
                const { lastError } = chrome.runtime;
                if (lastError) {
                    return reject(new Error(lastError.message));
                }
                const { data, error } = response;
                if (error) {
                    return reject(error);
                }
                resolve(data);
            });
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeConnection() { }
}
exports.E2EBlossomMessages = E2EBlossomMessages;
